import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { fmtCurrency, fmtDate } from './contactOverviewFormatUtils';
import { ProjectionEvent } from './contactOverviewTypes';

export default function ContactOverviewProjectionRow({ event }: { event: ProjectionEvent }) {
  const isPayout = event.eventType !== 'CAPITAL_CALL';
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1.5,
        py: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
        '&:last-child': { borderBottom: 'none' },
        alignItems: 'flex-start',
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: '50%',
          bgcolor: isPayout ? 'success.light' : 'warning.light',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          mt: 0.25,
        }}
      >
        {isPayout ? (
          <ArrowDownwardIcon sx={{ fontSize: 13, color: 'success.dark' }} />
        ) : (
          <ArrowUpwardIcon sx={{ fontSize: 13, color: 'warning.dark' }} />
        )}
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {fmtDate(event.eventDate)} — {event.fundName}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {isPayout ? 'Return' : 'Capital call'} {fmtCurrency(event.displayAmount)}
        </Typography>
      </Box>
    </Box>
  );
}
